/* InkMerge scoped storefront search — relevance repair September 2026. */
(function () {
  'use strict';

  var STUDIO_FILTER = 'tag:shop-designs';
  var PRO_FILTER = 'tag:"channel:dtf"';
  var ALL_MARKER = 'NOT tag:"__INKMERGE_SCOPE_ALL__"';

  function cleanTerm(value) {
    return String(value || '')
      .replace(/\s+AND\s+tag:shop-designs$/gi, '')
      .replace(/\s+AND\s+tag:(?:"|&(?:amp;)*quot;)channel:dtf(?:"|&(?:amp;)*quot;)$/gi, '')
      .replace(/\s+AND\s+NOT\s+tag:(?:"|&(?:amp;)*quot;)__INKMERGE_SCOPE_ALL__(?:"|&(?:amp;)*quot;)$/gi, '')
      .replace(/\s+product_type:(?:"|&(?:amp;)*quot;)(?:Graphic Tees|DTF Design)(?:"|&(?:amp;)*quot;)$/gi, '')
      .replace(/\s+NOT\s+product_type:(?:"|&(?:amp;)*quot;)__INKMERGE_SCOPE_ALL__(?:"|&(?:amp;)*quot;)$/gi, '')
      .replace(/^title:/i, '')
      .trim();
  }

  function searchableTerm(value) {
    return cleanTerm(value)
      .replace(/["\\:()]/g, ' ')
      .replace(/\s+/g, ' ')
      .slice(0, 120)
      .trim();
  }

  function scopedQuery(term, scope) {
    var clean = searchableTerm(term);
    if (!clean) return '';
    var titleQuery = 'title:' + clean;
    if (scope === 'pro') return titleQuery + ' AND ' + PRO_FILTER;
    if (scope === 'all') return titleQuery + ' AND ' + ALL_MARKER;
    return titleQuery + ' AND ' + STUDIO_FILTER;
  }

  function selectedScope(form) {
    var checked = form.querySelector('[name="scope"]:checked');
    return checked ? checked.value : (form.dataset.defaultScope || 'studio');
  }

  function initForm(form) {
    if (!form || form.dataset.searchScopeReady === 'true') return;
    form.dataset.searchScopeReady = 'true';

    var input = form.querySelector('[data-inkmerge-search-term]');
    if (!input) return;

    if (!form.querySelector('input[name="options[prefix]"]')) {
      var prefix = document.createElement('input');
      prefix.type = 'hidden';
      prefix.name = 'options[prefix]';
      prefix.value = 'last';
      form.appendChild(prefix);
    }

    form.addEventListener('submit', function (event) {
      var query = scopedQuery(input.value, selectedScope(form));
      if (!query) {
        event.preventDefault();
        input.focus();
        return;
      }
      input.value = query;
    });
  }

  function normalizeLegacySearch() {
    var root = document.querySelector('[data-inkmerge-search-normalize="true"]');
    if (!root) return;

    var scope = root.dataset.searchScope || 'studio';
    var url = new URL(window.location.href);
    var currentQuery = url.searchParams.get('q') || root.dataset.searchHumanTerm || '';
    var nextQuery = scopedQuery(currentQuery, scope);
    var alreadyNormalized =
      url.searchParams.get('q') === nextQuery &&
      url.searchParams.get('type') === 'product' &&
      url.searchParams.get('options[prefix]') === 'last';

    if (alreadyNormalized) return;

    url.searchParams.set('q', nextQuery);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    window.location.replace(url.toString());
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-inkmerge-search-form]'),
      initForm
    );
    normalizeLegacySearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
